// extracted by mini-css-extract-plugin
export default {"file":"FileThumb_file__BYkjl","file__image":"FileThumb_file__image__joiEx","file__icon":"FileThumb_file__icon__Ogo79"};